
<div class="container-fluid module-container" >
<ng-container *ngIf=" (token$| async) && (companies$ | async ) as companies ; else elseTemplate">
    <div class="content-container">
      <div class="row" [ngClass]="{ 'loading-filters': isLoadingFilter }">
        <mat-card class="filter-section filter-incadea">
          <section class="loading-container" *ngIf="isLoadingFilter">
            <div  class="pulsing" >
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing" >{{ "Searching" | translate }}
              {{ searchedElement | translate }}...</p>
          </section>

            <mat-form-field class="incadea-form-field">
                <mat-label class="filters-list-label"
                  >*{{ "Company" | translate  | capitalize}}</mat-label
                >
                <mat-select
                [(ngModel)]="selectedCompany"
                (ngModelChange)="getLocationsDepartmentsAndMakes(companies, selectedCompany)"
                >

                  <mat-option
                    *ngFor="let company of companies"
                    [value]="company"
                  >
                    {{ company.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="incadea-form-field">
                <mat-label class="filters-list-label"
                  >*{{ "Location" | translate | capitalize }}</mat-label
                >
                <mat-select
                [(ngModel)]="selectedLocation"
                [disabled]="!selectedCompany.Id"
                (ngModelChange)="onLocationChange()"
                >
                  <mat-option
                  *ngFor="let location of locations"
                  [value]="location"
                  >
                    {{ location.Description}}
                  </mat-option>
                </mat-select>
              </mat-form-field>


              <mat-form-field class="incadea-form-field">
                <mat-label class="filters-list-label"
                  >*{{ "Department" | translate | capitalize }}</mat-label
                >
                <mat-select
                [(ngModel)]="selectedDepartment"
                [disabled]="!selectedLocation?.Id"
                (ngModelChange)="onDepartmentChange($event)"
                >
                  <mat-option
                  [value]="department"
                    *ngFor="let department of departments$ | async"
                  >
                    {{ department.Description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="incadea-form-field">
                <mat-label class="filters-list-label"
                  >*{{ "Make" | translate | capitalize}}</mat-label
                >
                <mat-select
                [(ngModel)]="selectedMake"
                [disabled]="!selectedDepartment?.Id"
                (ngModelChange)="onMakeChange()"
                >
                  <mat-option
                  [value]="make"
                    *ngFor="let make of makes$ | async"
                  >
                    {{ make.Description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="incadea-form-field">
                <mat-label class="filters-list-label"
                  >*{{ "Service" | translate  | capitalize}}</mat-label
                >
                <mat-select
                [(ngModel)]="selectedService"
                [disabled]="!selectedMake?.Id"
                (ngModelChange)="onServiceChange()"
                >
                  <mat-option [value]="selectedService" *ngFor="let selectedService of services$ | async">
                    {{ selectedService.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="incadea-form-field">
                <mat-label class="filters-list-label"
                  >*{{ "Resource" | translate  | capitalize}}</mat-label
                >
                <mat-select
                [(ngModel)]="selectedResource"
                (ngModelChange)="onResourceChange()"
                [disabled]="!selectedService?.Id"
                >
                  <mat-option [value]="selectedResource" *ngFor="let selectedResource of resources$ | async">
                    {{ selectedResource.Description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div  class="searchAndCleanContainer col-lg-2">

                <button
                (click)="onClearClick()"
                  class="clearButton">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
        </mat-card>
      </div>
        <mat-card class="row calendar-and-plate-filter-container">
          <div class="row plate-filter-row">


              <div class="col-lg-3 plate-filter-column">
                <mat-form-field>
                  <mat-icon matPrefix>
                    <button
                    class="filter-box-button-plate filter-box-button-plate--fill"
                    (click)="onPlateNumberSearch()"
                    >
                      <i class="bi bi-search"></i>
                    </button>
                  </mat-icon>
                  <mat-label>{{ "Plate" | translate }}</mat-label>
                  <input matInput type="text" [(ngModel)]="plateNumber"/>
                  <mat-icon matSuffix>
                    <button
                    class="filter-box-button"
                    (click)="onClearPlate()"
                    >
                      <i class="bi bi-x-lg"></i>
                    </button>
                  </mat-icon>
                </mat-form-field>
              </div>
              <ng-container *ngFor="let legend of defaultLegends; let index = index">


                  <div class="col-lg-2 legend-item">
                    <div
                      class="color-icon"
                      [ngStyle]="{
                        'border-color': legend.legendConfig.backcolor,
                        background: legend.legendConfig.forecolor
                      }"
                    ></div>
                    <span class="legend-label">{{
                      legend.label | translate
                    }}</span>
                  </div>

              </ng-container>

          </div>
        </mat-card>


        <div class=" row fullcalendar-calendar">
          <div class="schedulerLoading" *ngIf="isLoading">
            <section>
              <div  class="pulsing">
                <mat-spinner [diameter]="50" ></mat-spinner>
              </div>
              <p class="pulsing">{{ "SearchingSchedulesAndAvalability" | translate }}...</p>
            </section>
          </div>
          <span *ngIf="appointments$ | async"></span>

          <full-calendar *ngIf="!isSearchingSchedules" style="height: 76vh; width: auto; font-family: ITCAvantGarden; margin:1rem"
          [options]="calendarOptions" [events]="schedulerEvents"   [ngClass]="{schedulerNotClickable: displayDefaultLegends}"
          >
          </full-calendar></div>


          </div>






</ng-container>
<ng-template #elseTemplate>

  <section class="schedulerLoading">
    <div  class="pulsing" >
      <mat-spinner [diameter]="50" ></mat-spinner>
    </div>
    <p class="pulsing" >{{ "Loading" | translate }}...</p>
  </section>
</ng-template>

</div>

